module.exports = [{
      plugin: require('/tmp/f3f50bb/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
